import Select from 'react-select'
import './DateRangeInput.scoped.scss'

const MODE_OPTIONS = [
  { value: 'between', label: 'between' },
  { value: 'after', label: 'after' },
  { value: 'before', label: 'before' },
  { value: 'inTheLast', label: 'in the last' },
]

const UNIT_OPTIONS = [
  { value: 'days', label: 'days' },
  { value: 'weeks', label: 'weeks' },
  { value: 'months', label: 'months' },
  { value: 'years', label: 'years' },
]

function deriveMode(value) {
  if (!value || typeof value !== 'object') return 'between'
  if (value.relative !== undefined) return 'inTheLast'
  if (value.from && value.to) return 'between'
  if (value.from) return 'after'
  if (value.to) return 'before'
  return 'between'
}

export default function DateRangeInput({ value, onChange }) {
  const safeValue = value && typeof value === 'object' ? value : {}
  const [mode, setMode] = useState(() => deriveMode(value))

  function handleModeChange(option) {
    const newMode = option.value
    setMode(newMode)
    switch (newMode) {
      case 'between':
        return onChange({ from: '', to: '' })
      case 'after':
        return onChange({ from: '' })
      case 'before':
        return onChange({ to: '' })
      case 'inTheLast':
        return onChange({ relative: '', unit: 'days' })
    }
  }

  function update(key, val) {
    onChange({ ...safeValue, [key]: val })
  }

  return (
    <div className="date-range-input">
      <div className="date-range-mode">
        <Select
          options={MODE_OPTIONS}
          value={_.find(MODE_OPTIONS, { value: mode })}
          onChange={handleModeChange}
        />
      </div>
      {mode === 'between' && (
        <>
          <input
            type="date"
            value={safeValue.from || ''}
            onChange={(e) => update('from', e.target.value)}
          />
          <span className="date-range-label">and</span>
          <input
            type="date"
            value={safeValue.to || ''}
            onChange={(e) => update('to', e.target.value)}
          />
        </>
      )}
      {mode === 'after' && (
        <input
          type="date"
          value={safeValue.from || ''}
          onChange={(e) => update('from', e.target.value)}
        />
      )}
      {mode === 'before' && (
        <input
          type="date"
          value={safeValue.to || ''}
          onChange={(e) => update('to', e.target.value)}
        />
      )}
      {mode === 'inTheLast' && (
        <>
          <input
            type="number"
            style={{ width: '80px' }}
            value={safeValue.relative || ''}
            onChange={(e) => update('relative', e.target.value)}
          />
          <div className="date-range-unit">
            <Select
              options={UNIT_OPTIONS}
              value={_.find(UNIT_OPTIONS, { value: safeValue.unit || 'days' })}
              onChange={(option) => update('unit', option.value)}
            />
          </div>
        </>
      )}
    </div>
  )
}
